import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { BASIS_OPTIONS } from './aiqMeta';

export const InvoiceBasisSelect = ({ value, onChange, disabled, testId }) => (
  <Select value={value || ''} onValueChange={onChange} disabled={disabled}>
    <SelectTrigger
      className={`h-8 w-[110px] text-xs ${value ? '' : 'border-amber-400 bg-amber-50 text-amber-900'}`}
      data-testid={testId}
    >
      <SelectValue placeholder="Choose…" />
    </SelectTrigger>
    <SelectContent>
      {BASIS_OPTIONS.map((o) => (
        <SelectItem key={o.value} value={o.value} data-testid={`${testId}-${o.value}`}>{o.label}</SelectItem>
      ))}
    </SelectContent>
  </Select>
);
